// Dummy cursor manager that does nothing.
class LoopbackCursorManager {
  destroy() {}
  sendCursor() {}

  showCursorName() {}
}

export default LoopbackCursorManager;
